<template>
    <section class="app-main">

        <div class="top-bar">
            <!-- <el-date-picker v-model="date" type="date"  value-format="yyyy-MM-dd" placeholder="申请日期"></el-date-picker> -->
            <el-input placeholder="搜索商家名称" v-model="title"  style="width:300px;" @change="search()" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <el-card>
            <el-table :data="tableData" v-loading="table_load" height="600">
                <el-table-column  prop="title"    label="商家名称"    width="200" align="center" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column  prop="email"    label="企业邮箱"    width="200" align="center" > </el-table-column> -->
                <el-table-column  prop="batch"    label="企业联系人"  width="180" align="center">
                    <template slot-scope="scope">
                        <el-link type="info" v-if="scope.row.id == 1">{{scope.row.deliver_contacts}}</el-link>
                        <el-link type="info" v-if="scope.row.shops_apply">{{scope.row.shops_apply.surname}} {{scope.row.shops_apply.name}} </el-link>
                    </template>
                </el-table-column>
                <el-table-column  prop="shops_apply.phone"    label="联系电话"    width="180" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.id == 1">{{scope.row.deliver_phone}}</span>
                        <span v-else>{{scope.row.shops_apply.phone}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="shops_apply.cid_title" label="经营类目"    width="180" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.id == 1">{{scope.row.shop_content}}</span>
                        <span v-else>{{scope.row.shops_apply.cid_title}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="updated_at" label="申请时间"   width="180"  align="center" ></el-table-column>
                <el-table-column   label="编辑"   width="180"  align="center" >
                    <template slot-scope="scope">
                        <el-button size="small" @click="startCheck(scope.row)" v-if="scope.row.id != 1">查看信息</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper"  style="padding:10px" :page-size="size" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>


        <el-dialog title="申请信息表" :visible.sync="edit_modal" :show-close="false" width="1000px" align="center">
            <el-card class="m-bottom-4">
                 <el-row :gutter="20" style="margin-bottom:10px">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="4" class="shop-title">{{row.shops_type == 1 ? '企业名称' : '店铺名称' }}</el-col>
                            <el-col :span="20" class="shop-info">{{row.corporate_name}}</el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">企业联系人</el-col>
                            <el-col :span="20" class="shop-info">{{row.surname}} {{row.name}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:10px" >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">经营类目</el-col>
                            <el-col :span="20" class="shop-info">{{row.cid_title}}</el-col>
                        </el-row>
                    </el-col >
                    <!-- <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系人职务</el-col>
                            <el-col :span="20" class="shop-info">{{row.post}}</el-col>
                        </el-row>
                    </el-col> -->
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px" >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系邮箱</el-col>
                            <el-col :span="20" class="shop-info">{{row.email}}</el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="4" class="shop-title">联系电话</el-col>
                            <el-col :span="20" class="shop-info">{{row.phone}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row  v-if="row.country">
                    <p class="shop-title">企业发货地址：{{row.addr}} {{row.city.ename}}-{{row.province.ename}}-{{row.country.ename}}</p>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row  v-if="row.shops_type == 1">
                    <el-col :span="2" class="img-title">营业执照</el-col>
                    <el-col :span="22" class="imgs-box">
                        <m-img  :src="row.license_pic_url" :width="160" :height="160" />
                    </el-col>
                </el-row>
                <el-row style="margin-bottom:20px" v-if="row.shops_type == 0">
                    <el-col :span="2" class="img-title">身份认证</el-col>
                    <el-col :span="22" class="imgs-box">
                        <m-img  :src="row.id_card_pic_one_url" />
                        <m-img  :src="row.id_card_pic_two_url" />
                    </el-col>
                </el-row>
            </el-card>

            <el-card>
                <el-row  class="m-bottom-3">
                    <el-col :span="3" class="label-title">入驻费率</el-col>
                    <el-col :span="21" class="label-box">
                       <el-input v-model="entry_rate"  style="width:195px" >
                           <span slot="append">%</span>
                       </el-input>
                    </el-col>
                </el-row>
                <el-row  class="m-bottom-3">
                    <el-col :span="3" class="label-title">包装费用</el-col>
                    <el-col :span="21" class="label-box">
                        <el-radio-group v-model="is_packing">
                            <el-radio :label="0" border>No</el-radio>
                            <el-radio :label="1" border>Yes</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <el-row  class="m-bottom-3">
                    <el-col :span="3" class="label-title">入库MOOBY</el-col>
                    <el-col :span="21" class="label-box">
                        <el-radio-group v-model="is_mooby_stock">
                            <el-radio :label="0" border>No</el-radio>
                            <el-radio :label="1" border>Yes</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-3">
                    <el-col :span="3" class="label-title">能否自提</el-col>
                    <el-col :span="21" class="label-box">
                        <el-radio-group v-model="self_pick_up">
                            <el-radio :label="0" border>No</el-radio>
                            <el-radio :label="1" border>Yes</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="3" class="label-title">确定修改</el-col>
                    <el-col :span="21" class="label-box">
                       <el-button type="success" plain @click="setAuth()">提 交 修 改</el-button>
                    </el-col>
                </el-row>
            </el-card>
           

        </el-dialog>


    </section>
</template>



<script>
import { shop_list, shops_get, shops_set } from '@/api/merchant.js'
import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            title: "",
            page:1,
            total:0,
            size: 20,
            tableData:[],
            row:{},
            edit_modal: false,
            innerVisible: false,
            entry_rate: '',
            is_packing: 0,
            is_mooby_stock: 0,
            self_pick_up:0,
            reasons:'',
            id:''
        }
    },
    methods: {
        getData(){
            let params = {
                page: this.page
            }
            if (this.title != "") {
                params.title_search = this.title
            }
            shop_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }
            })
        },
        search() {
            this.page = 1;
            this.getData();
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        startCheck(row){
            this.getAuth(row.id)
            this.row = row.shops_apply;
            this.id = row.id
            this.edit_modal = true;
        },
        // 获取店铺权限费率
        getAuth(id) {
            shops_get(id).then(res => {
                if(res) {
                    this.entry_rate = res.data.entry_rate
                    this.is_packing = res.data.is_packing
                    this.is_mooby_stock = res.data.is_mooby_stock
                    this.self_pick_up = res.data.self_pick_up
                }
            })
        },

        // 设置店铺权限费率
        setAuth() {
            if(this.entry_rate == '') {
                this.$message.error('入驻费率不能为空')
            }
            let params =  {
                entry_rate:this.entry_rate,
                is_packing:this.is_packing,
                is_mooby_stock:this.is_mooby_stock,
                self_pick_up:this.self_pick_up
            }
            this.$confirm('确定修改吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                shops_set(this.id, params).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:"success",})
                        this.edit_modal = false;
                    }else{
                        this.$message({message:res.msg,type:"error",})
                    }
                })
            }).catch(() => {});
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.shop-title {
    text-align: left;
    height: 40px;
    line-height: 40px;
}
.img-title {
    text-align: left;
    height: 70px;
    line-height: 70px;
}
.shop-info {
    border: 1px solid #e0e0e0;
    text-align: left;
    padding-left: 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
}
.imgs-box {
    text-align: left;
}
.label-title {
    height: 40px;
    line-height: 40px;
}
.label-box {
    text-align: left;
}



</style>

